import { useMemo } from 'react';
import { Language, Product, UomElement } from 'types/schema';

const useProductUomInfo = (product: Product) => {
  const { uom, netUom, baseUom, baseUnit, netUnit } = product;
  const lang = localStorage.getItem('lang') || Language.Vi;
  const baseUoms = JSON.parse(localStorage.getItem('baseUoms') || '{}');
  const netUoms = JSON.parse(localStorage.getItem('netUoms') || '{}');
  const uoms = JSON.parse(localStorage.getItem('uoms') || '{}');
  const langName = lang === Language.Vi ? 'nameVn' : 'nameEn';

  const currUom: string = uom ? uoms?.[uom]?.[langName] : '';
  const currNetUom: string = netUom ? netUoms?.[netUom]?.[langName] : '';
  const currBaseUom: string = useMemo(() => {
    if (!baseUom || !baseUoms) return '';
    const arrBaseUoms = Object.values(baseUoms);
    const result = arrBaseUoms.find((item: UomElement) => item[langName] === baseUom);
    return result?.[langName] || '';
  }, [baseUom, baseUoms, langName]);

  const uomInfo = useMemo(() => {
    if (!baseUnit || !currBaseUom || !currUom) return '';

    const isSameUom = currBaseUom === currNetUom;
    const isSameBaseUom = currBaseUom === currUom;

    if (currNetUom && netUnit) {
      if (baseUnit === 1) return `${netUnit}${currNetUom}${!isSameUom ? `/${currUom}` : ''}`;
      return `${baseUnit} ${currBaseUom}${netUnit && currNetUom ? ' x ' : ''}${netUnit || ''}${currNetUom || ''}${!isSameUom ? `/${currUom}` : ''}`;
    }

    return `${baseUnit} ${currBaseUom}${!isSameBaseUom ? `/${currUom}` : ''}`;
  }, [baseUnit, currBaseUom, netUnit, currNetUom, currUom]);

  return {
    uomInfo: uomInfo,
    baseUom: currBaseUom,
    netUom: currNetUom,
  };
};

export default useProductUomInfo;
